import { HttpClient, HttpParams } from '@angular/common/http';
import { computed, inject, Injectable, resource } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { BusinessEntityResponse } from '../../models/business-entity.model';
import { Option } from '../../models/common.models';
import { RegionService } from '../region/region.service';
import { mapBusinessEntityResponseToModel } from './business-entity.mapper';

@Injectable({
  providedIn: 'root',
})
export class BusinessEntityService {
  private readonly http = inject(HttpClient);
  private readonly regions = inject(RegionService);

  private readonly businessEntities$ = (regionId?: number) => {
    const options = regionId
      ? { params: new HttpParams().set('regionid', String(regionId)) }
      : {};
    return this.http
      .get<BusinessEntityResponse[]>('BusinessEntity', options)
      .pipe(
        map((response: BusinessEntityResponse[]) =>
          response.map((response) =>
            mapBusinessEntityResponseToModel(response, this.regions.regions()),
          ),
        ),
      );
  };

  readonly businessEntities = resource({
    params: () => this.regions.selectedRegionId(),
    loader: ({ params }) => lastValueFrom(this.businessEntities$(params)),
    defaultValue: [],
  });

  readonly allBusinessEntities = resource({
    loader: () => lastValueFrom(this.businessEntities$()),
    defaultValue: [],
  });

  readonly businessEntityOptions = computed<Option[]>(() =>
    this.businessEntities.value().map((businessEntity) => ({
      label: businessEntity.name,
      value: businessEntity.code,
    })),
  );

  downloadBusinessEntities() {
    return this.http.get('BusinessEntity/download', {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
